import { DataSourceExecutionEvent, ClickEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutEdiProfileOrderQuickInfo } from "./autogen/AutogenLayoutEdiProfileOrderQuickInfo";
import { EdiUtility } from "./EdiUtility";
import { TenderProfile } from "./TenderProfile";

export class EdiProfileOrderQuickInfo extends AutogenLayoutEdiProfileOrderQuickInfo {

    doAfterExecute(event: DataSourceExecutionEvent) {
        if (StringUtil.isEmptyString(this.sourceEdiorderProfile.activeRow?.get("notes"))) {
            this.labelPartnerNotesImage.enabled = false;
            this.labelPartnerNotesImage.imageColor = "subtle.light";
            this.labelPartnerNotesImage.tooltip = "No partner notes available"
        }
    }

    openClassicPartnerProfile(event: ClickEvent): void {
        const id = this.sourceEdiorderProfile?.activeRow?.get("id");
        if (id != null) {
            TenderProfile.navigateTo(id);
        }
    }

    showPartnerNotes() {
        EdiUtility.showPartnerNotes(this.sourceEdiorderProfile.activeRow?.get("id"),
            this.sourceEdiorderProfile.activeRow?.get("partner_name"), this.sourceEdiorderProfile.activeRow?.get("notes"));
    }
}
